/* eslint-disable */

// TODO: refatorar esse componente habilitando o eslint
import React, { createContext, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';

import {
	apiLucree,
	apiTransacao,
	apiGrupos,
	apiPGM,
} from '../services/api';

export const TransactionsContext = createContext([]);

export function TransactionsProvider(props) {
	const { children, user } = props;

	const [tokenState, setTokenState] = useState('');

	const [loadingTransactions, setLoadingTransactions] = useState(true);

	const [loaderDownload, setLoaderDownload] = useState(false);

	const [dadosLojista, setDadosLojista] = useState('');

	const [gruposTitularConcatenado, setGruposTitularConcatenado] = useState([]);

	const [transacoes, setTransacoes] = useState({
		hoje: {
			dados: {},
			loading: true,
			error: null,
		},
		ontem: {
			dados: {},
			loading: true,
			error: null,
		},
		dias30: {
			dados: {},
			loading: true,
			error: null,
		},
	});

	const [bandeiras, setBandeiras] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [modalidade, setModalidade] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [topDias, setTopDias] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [graficoEvolutivo, setGraficoEvolutivo] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [transacoes7Dias, setTransacoes7Dias] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [transacoesDataPickerEnd, setTransacoesDataPickerEnd] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [ultimasTransacoes, setUltimasTransacoes] = useState({
		lista: [],
		loading: true,
		error: null,
	});

	const [transacoesGrupo, setTransacoesGrupo] = useState({
		data: [],
		lista: [],
		listaConcatenadaGrupo: [],
		listaGrupoDownload: [],
		loading: true,
		error: null,
	});

	const [totalGrupos, setTotalGrupos] = useState({
		total_vendas: 0,
		total_debito: 0,
		total_credito: 0,
		total_parcelado2a6: 0,
		total_parcelado7a12: 0,
		total_parcelado13a18: 0,
		total_parcelado19a24: 0,
		total_paginas: 0,
		total_registros: 0,
	});

	function orderDateMatched(dateA, dateB) {
		return moment(dateA.data_transacao) - moment(dateB.data_transacao);
	}

	async function authToken() {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);
			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}

	async function authentication(idTitular) {
		var idTitularBase = '';

		idTitular === 'todos' ? (idTitularBase = user.dados.user_id) : idTitularBase = idTitular
		try {
			const data = {
				'username': 'daniel.nascimento',
				'password': 'acessoLucree#2018'
			};
			await apiLucree.post(
				`autenticacao/v1/`, data
			).then(res => (
				setTokenState(res.data.id_token),
				getTransacoes(1, res.data.id_token, idTitularBase),
				getBandeiras(res.data.id_token, idTitularBase),
				getModalidades(res.data.id_token, idTitularBase),
				getTopDiasVendas(res.data.id_token),
				getUltimasTransacoes(res.data.id_token, idTitularBase),
				getGraficoEvolutivo(res.data.id_token)),
			)

		} catch (error) {
			toast.error('Os dados de autenticação de transação não foram carregados. Por favor atualize a página');
		}
	}

	function selectGroup(groups) {
		if (groups.length == 1)
			return groups[0]

		const tipos = groups.map(x => (x.grupo_content || {}).relacao_tipo || "grupo")

		const indexSplit = tipos.indexOf("split")
		if (indexSplit >= 0 && groups[indexSplit].is_root) {
			return groups[indexSplit]
		}

		const indexGrupo = tipos.indexOf("grupo")
		return groups[indexGrupo]
	}

	async function authGroup(params, page, filter, idTitular, showFields) {
		if(['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0 && user.dados.permissoes.view_pgm) {
			try {
				if(idTitular !== 'todos'){
					getAllTransacoesPGM(params, page, showFields, idTitular)
				} else {
					getAllTransacoesPGM(params, page, showFields)
				}
			} catch (error) {
				toast.error('Os dados de autenticação de grupo não foram carregados. Por favor atualize a página');
			}
		} else {
			try {
				const data = {
					'username': 'daniel.nascimento',
					'password': 'acessoLucree#2018'
				};
				await apiLucree.post(
					`autenticacao/v1/`, data
				).then(resAuthentication =>
					['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0 ?
						getLojista(resAuthentication.data.id_token).then(resLojista => {
							const group = selectGroup(resLojista)

							if (group.is_root){
								showFields()
							}


							getLojistasGrupo(resAuthentication.data.id_token, group.grupo_nome);
							setDadosLojista(group.grupo_nome);
							getTransacoesGrupoAuthentication(resAuthentication.data.id_token, params, page, group.grupo_nome, filter, idTitular)
						})
						:
						getTransacoesGrupoAuthentication(resAuthentication.data.id_token, params, page, '', filter, idTitular)
				)
			} catch (error) {
				toast.error('Os dados de autenticação de grupo não foram carregados. Por favor atualize a página');
			}
		}
	}

	async function getTransacoesGrupoAuthentication(token, params, page, resLojista, filter, idTitular) {
		if (['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0) {
			idTitular !== 'todos' ?
				getTransacoesGrupo(resLojista, token, params, page, filter, idTitular)
					: getAllTransacoesGrupoConcatenado(
						token,
						params,
						page,
						resLojista,
						idTitular
				)
		} else if (user.dados.tipo_cliente === 'simples') {
			if (filter === 'todos') {
				getTransacoes(page, token, user.dados.user_id);
			} else if (filter === 'sete_dias') {
				getTransacoes7Dias(page, token);
			} else if (filter === 'data_picker_end') {
				getTransacoesDataPickerEnd(page, params.dateEnd, params, token);
			}
		}
	}

	async function getTransacoesDataPickerEnd(page, value, dataRange, tokenValue) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {
			setLoadingTransactions(true);

			await apiTransacao.get(
				`transacoes/${user.dados.user_id}?init_date=${moment(dataRange.dateInit).format('YYYY-MM-DD')}&end_date=${moment(value).format('YYYY-MM-DD')}&page=${page}`, {
			}, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res =>
				{
					setTransacoesDataPickerEnd({
						lista: res.data,
						loading: false,
						error: null
					})

					setTotalGrupos({
						...totalGrupos,
						total_paginas: res.data.paginas || 0,
						total_registros: res.data.total_registros || 0,
					});
				}

			)
			setLoadingTransactions(false);

		} catch (error) {
			setLoadingTransactions(false);
			toast.error('As transações nas datas selecionadas não foram carregadas. Por favor atualize a página');
		}
	}

	async function getTransacoes7Dias(page, tokenValue) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {

			setLoadingTransactions(true);

			await apiTransacao.post(
				`transacoes_cliente/`, {
				idUsu: user.dados.user_id,
				filters: {
					dateInit: moment()
						.subtract(7, 'days')
						.format('YYYY-MM-DD'),
					dateEnd: moment().format('YYYY-MM-DD'),
				},
				orderBy: [{ payment_date: 'DESC' }],
				// orderBy: [{ name: 'payment_date' }],
				page: page,
				perPage: 0
			}, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res => {
				setTransacoes7Dias({
					lista: res.data,
					loading: false,
					error: null
				})
			}
			)

			setLoadingTransactions(false);

		} catch (error) {
			setLoadingTransactions(false);
			toast.error('As transações de 7 dias não foram carregadas. Por favor atualize a página');
		}
	}

	async function getTransacoes(page, tokenValue, idTitular) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {
			setLoadingTransactions(true);

			const dados = await apiTransacao.post(
				`transacoes_cliente/`, {
				idUsu: idTitular,
				filters: {
					dateInit: moment().format('YYYY-MM-DD'),
					dateEnd: moment().format('YYYY-MM-DD'),
				},
			}, {
				orderBy: [{ payment_date: 'DESC' }],
				page: page,
				perPage: 0,
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			});

			const dadosOntem = await apiTransacao.post(
				`transacoes_cliente/`, {
				idUsu: idTitular,
				filters: {
					dateInit: moment()
						.subtract(1, 'days')
						.format('YYYY-MM-DD'),
					dateEnd: moment()
						.subtract(1, 'days')
						.format('YYYY-MM-DD'),
				},
			}, {
				orderBy: [{ payment_date: 'DESC' }],
				page: page,
				perPage: 10,
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			});

			const dados30Dias = await apiTransacao.post(
				`transacoes_cliente/`, {
				idUsu: idTitular,
				filters: {
					dateInit: moment()
						.subtract(30, 'days')
						.format('YYYY-MM-DD'),
					dateEnd: moment().format('YYYY-MM-DD'),
				},
				orderBy: [{ payment_date: 'DESC' }],
				page: page,
				perPage: 10,
			}, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			});

			// Consulta de dados das últimas vendas
			await apiTransacao.post(
				`transacoes_cliente/`, {
				idUsu: idTitular,
				filters: {
					dateInit: moment()
						.subtract(30, 'days')
						.format('YYYY-MM-DD'),
					dateEnd: moment().format('YYYY-MM-DD'),
				},
				orderBy: [{ payment_date: 'DESC' }],
				page: page,
				perPage: 0,
			}, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			});

			setTransacoes({
				hoje: {
					dados: dados.data,
					loading: false,
					error: null
				},
				ontem: {
					dados: dadosOntem.data,
					loading: false,
					error: null
				},
				dias30: {
					dados: dados30Dias.data,
					loading: false,
					error: null
				}
			});
			setLoadingTransactions(false);
		} catch (error) {
			setLoadingTransactions(false);
			toast.error('Algumas transações não foram carregadas. Por favor atualize a página');
		}
	}

	async function getUltimasTransacoes(tokenValue, idTitular) {
		var list = [];
		try {
			await apiTransacao.get(
				`transacoes-cliente/${idTitular}/ultimos?items=9`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': tokenValue
					}
				}).then(res => {
					res.data.map(item => list.push(item));
				})

			// list.sort(compare)

			setUltimasTransacoes({
				lista: list,
				loading: false,
				error: null
			})

		} catch (error) {
			toast.error('As últimas transações não foram carregadas. Por favor atualize a página');
		}
	}

	async function getTransacoesGrupo(dadosTransacoesGrupoLojista, tokenValue, params, pagina, filter, idTitular) {
		if (tokenState !== '') {
			tokenValue = tokenState;
		}
		try {
			setLoadingTransactions(true);
			await apiTransacao.get(
				`transacoes-group/${dadosTransacoesGrupoLojista}/${idTitular}/?items=10&init_date=${params.dateInit}&end_date=${params.dateEnd}&page=${pagina}`, {
				// `transacoes-group/${dadosLojista}/${user.dados.lojista_id}/?init_date=${params.dateInit}&end_date=${params.dateEnd}&=page=${pagina - 1}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res => {
				setTotalGrupos({
					total_vendas: 0,
					total_debito: 0,
					total_credito: 0,
					total_parcelado2a6: 0,
					total_parcelado7a12: 0,
					total_parcelado13a18: 0,
					total_parcelado19a24: 0,
					total_paginas: 0,
					total_registros: 0,
				});

				const arrayLista = [];
				const arrayListaConcatenadaGrupo = [];
				const arrayListaGrupoDownload = [];
				var cont = 0;

				Object.keys(res.data).forEach(item => {
					if (Number(item) === Number(idTitular)) {

						// Concatenando Pages
						res.data[item].data.map(itemMap => {
							arrayListaGrupoDownload.push(itemMap);
							const index = parseInt(Number(cont / 10));
							if ((arrayListaConcatenadaGrupo.length - 1) < index) {
								arrayListaConcatenadaGrupo.push([]);
							}
							arrayListaConcatenadaGrupo[index].push(itemMap);
							cont++;
						})

						setTotalGrupos({
							total_vendas: res.data[item].total_geral,
							total_debito: res.data[item].total_debito,
							total_credito: res.data[item].total_credito,
							total_parcelado2a6: res.data[item].total_parcelo2a6,
							total_parcelado7a12: res.data[item].total_parcelo7a12,
							total_parcelado13a18: res.data[item].total_parcelo13a18,
							total_parcelado19a24: res.data[item]?.total_parcelo19a24 || 0,
							total_paginas: res.data[item].paginas ? res.data[item].paginas : 0,
							total_registros:res.data[item].total_registros ? res.data[item].total_registros : 0,
						});
					}

					if (Number(user.dados.lojista_id) !== Number(item)) {
						arrayLista.push(res.data[item]);
					}

				});
				setTransacoesGrupo({
					data: res.data,
					lista: arrayLista,
					listaConcatenadaGrupo: arrayListaConcatenadaGrupo,
					listaGrupoDownload: arrayListaGrupoDownload,
					loading: false,
					error: null
				});

				setLoadingTransactions(false);
			});

		} catch (error) {
			setLoadingTransactions(false);
			console.log('As transações de grupo não foram carregados. Por favor atualize a página');
		}
	}

	async function getAllTransacoesGrupoConcatenado(tokenValue, params, pagina, dadosLojista, idTitular) {
		if (tokenState !== '') {
			tokenValue = tokenState;
		}

		setTotalGrupos({
			total_vendas: 0,
			total_debito: 0,
			total_credito: 0,
			total_parcelado2a6: 0,
			total_parcelado7a12: 0,
			total_parcelado13a18: 0,
			total_parcelado19a24: 0,
			total_paginas: 0,
			total_registros: 0,
		});

		try {
			setLoadingTransactions(true);

			var arrayTotalGrupos = {
				total_vendas: 0,
				total_debito: 0,
				total_credito: 0,
				total_parcelado2a6: 0,
				total_parcelado7a12: 0,
				total_parcelado13a18: 0,
				total_parcelado19a24: 0,
				total_paginas: 0,
				total_registros: 0,
			};

			await apiTransacao.get(
				`transacoes-group-concat/${dadosLojista}/${user.dados.lojista_id}?init_date=${params.dateInit}&end_date=${params.dateEnd}&page=${pagina}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res => {
				const arrayLista = [];
				const arrayListaConcatenadaGrupo = [];
				const arrayListaGrupoDownload = [];
				var cont = 0;

				if (Object.keys(res.data).length !== 0) {
					res.data.data.data.map(item => {
						// Valores para Cards
						arrayLista.push(item);

						arrayTotalGrupos = {
							total_vendas: arrayTotalGrupos.total_vendas + item.valor_transacao,
							total_debito: item.modalidade === 'débito' ? arrayTotalGrupos.total_debito + item.valor_transacao : arrayTotalGrupos.total_debito,
							total_credito: item.modalidade === 'crédito à vista' ? arrayTotalGrupos.total_credito + item.valor_transacao : arrayTotalGrupos.total_credito,
							total_parcelado2a6: item.modalidade === 'Crédito Parcelado' && (item.parcelas >= 2 && item.parcelas <= 6)
								?
								arrayTotalGrupos.total_parcelado2a6 + item.valor_transacao : arrayTotalGrupos.total_parcelado2a6,

							total_parcelado7a12: item.modalidade === 'Crédito Parcelado' && (item.parcelas >= 7 && item.parcelas <= 12)
								?
								arrayTotalGrupos.total_parcelado7a12 + item.valor_transacao : arrayTotalGrupos.total_parcelado7a12,
							total_parcelado13a18: item.modalidade === 'Crédito Parcelado' && (item.parcelas >= 13 && item.parcelas <= 18)
								?
								arrayTotalGrupos.total_parcelado13a18 + item.valor_transacao : arrayTotalGrupos.total_parcelado13a18,
							total_parcelado19a24: item.modalidade === 'Crédito Parcelado' && (item.parcelas >= 19 && item.parcelas <= 24)
								?
								arrayTotalGrupos?.total_parcelado19a24 + item.valor_transacao : arrayTotalGrupos?.total_parcelado19a24
						};

					})
				}

				setTotalGrupos({
					total_vendas: arrayTotalGrupos.total_vendas,
					total_debito: arrayTotalGrupos.total_debito,
					total_credito: arrayTotalGrupos.total_credito,
					total_parcelado2a6: arrayTotalGrupos.total_parcelado2a6,
					total_parcelado7a12: arrayTotalGrupos.total_parcelado7a12,
					total_parcelado13a18: arrayTotalGrupos.total_parcelado13a18,
					total_parcelado19a24: arrayTotalGrupos?.total_parcelado19a24 || 0,
				});

				if (res.data.data.total_geral) {
					setTotalGrupos({
						total_vendas: res.data.data.total_geral,
						total_debito: res.data.data.total_debito,
						total_credito: res.data.data.total_credito,
						total_parcelado2a6: res.data.data.total_parcelo2a6,
						total_parcelado7a12: res.data.data.total_parcelo7a12,
						total_parcelado13a18: res.data.data.total_parcelo13a18,
						total_parcelado19a24: res.data.data?.total_parcelo19a24 || 0,
						total_paginas:  res.data.data.total_paginas || res.data.data.paginas || 0,
						total_registros:  res.data.data.total_registros || 0,
					});
				}

				// Concatenando Pages
				arrayLista.map(itemMap => {
					arrayListaGrupoDownload.push(itemMap);
					const index = parseInt(cont / 10);
					if ((arrayListaConcatenadaGrupo.length - 1) < index) {
						arrayListaConcatenadaGrupo.push([]);
					}
					arrayListaConcatenadaGrupo[index].push(itemMap);
					cont++;
				})

				setTransacoesGrupo({
					data: '',
					lista: arrayLista,
					listaConcatenadaGrupo: arrayListaConcatenadaGrupo,
					listaGrupoDownload: '',
					loading: false,
					error: null
				});

			});

			setLoadingTransactions(false);

		} catch (error) {
			setLoadingTransactions(false);
			// getRecebimentosGeral(tokenValue, params, pagina)
			console.error('Dados de transacoes de grupos concatenados não foram carregados. Por favor atualize a página');
		}
	}

	async function getAllTransacoesPGM(params, pagina, showFields, documento = '') {
		setTotalGrupos({
			total_vendas: 0,
			total_debito: 0,
			total_credito: 0,
			total_parcelado2a6: 0,
			total_parcelado7a12: 0,
			total_parcelado13a18: 0,
			total_parcelado19a24: 0,
			total_paginas: 0,
			total_registros: 0,
		});

		try {
			setLoadingTransactions(true);
			const res = await apiPGM.get(
				`transacoes?init_date=${params.dateInit}&end_date=${params.dateEnd}&page=${pagina}${documento && documento !== 'todos' ? `&documento=${documento}` : ''}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${user.token.access}`
				}
			})

			if(res){
				if(res?.data?.is_root){
					let newRelacoes = res?.data?.relacoes.map(item => ({
						id: item.documento,
						grupo: {
						  documento: item.documento,
						  nome: item.nome
						}
					}));
					setGruposTitularConcatenado(newRelacoes || [])
					showFields()
				}

				let arrayLista = [];
				let arrayListaConcatenadaGrupo = [];
				let arrayListaGrupoDownload = [];

				if (res?.data?.total_geral) {
					setTotalGrupos({
						total_vendas: res.data.total_geral,
						total_debito: res.data.total_debito,
						total_credito: res.data.total_credito,
						total_parcelado2a6: res.data.total_parcelo2a6,
						total_parcelado7a12: res.data.total_parcelo7a12,
						total_parcelado13a18: res.data.total_parcelo13a18,
						total_parcelado19a24: res?.data?.total_parcelo19a24 || 0,
						total_paginas: res.data.total_paginas || 0,
						total_registros: res.data.total_registros || 0,
					});
				}

				if(res?.data?.data){
					arrayLista.push(res.data.data)
					arrayListaGrupoDownload.push(res.data.data)
					arrayListaConcatenadaGrupo.push(res.data.data)
				}


				setTransacoesGrupo({
					data: '',
					lista: arrayLista,
					listaConcatenadaGrupo: arrayListaConcatenadaGrupo,
					listaGrupoDownload: '',
					loading: false,
					error: null
				});
			}
			setLoadingTransactions(false);
			return res;
		} catch (error) {
			setLoadingTransactions(false);
			// getRecebimentosGeral(tokenValue, params, pagina)
			console.error('Dados de transacoes de grupos concatenados não foram carregados. Por favor atualize a página');
			return error;
		}
	}

	async function getLojista(tokenValue) {
		try {
			const dadosLojista = await apiGrupos.get(`/api/lojista/${user.dados.lojista_id}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			})
			return dadosLojista.data.data;
		} catch (error) {
			console.log('Os dados de lojista não foram carregados.', error);
		}
	}

	async function getLojistasGrupo(tokenValue, grupoNome) {
		try {
			const arrayConcatenarGrupo = [];

			await apiGrupos.get(`/api/grupos/${grupoNome}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res => {
				const tree = res.data.data.tree;
				const root = res.data.data.root;

				// Titular (Pai)
				arrayConcatenarGrupo.push({
					id: root,
					grupo: tree[root].sub
				})
				Object.entries(tree[root].children).map((key, item) => {
					// Filhos
					arrayConcatenarGrupo.push({
						id: key[0],
						grupo: key[1].sub
					})
				})
				// Retirando Tinta Iquine da lista
				const arrayConcatenarGrupoOrdenado = arrayConcatenarGrupo.sort(function (a, b) {
					if (a.id !== "17157") {
						return a.grupo.nome < b.grupo.nome ? -1 : a.grupo.nome > b.grupo.nome ? 1 : 0;
					}
				});
				// arrayConcatenarGrupoOrdenado.shift()
				//

				setGruposTitularConcatenado(arrayConcatenarGrupoOrdenado)
			})


		} catch (error) {
			console.log('Os dados do lojista grupo não foram carregados.', error);
		}
	}

	async function getBandeiras(tokenValue, idTitular) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {
			await apiTransacao.get(
				`qtd-transacoes-bandeira/${idTitular}/${moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')}/${moment().format('YYYY-MM-DD')}`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': tokenValue
					}
				}
			).then(res =>
				setBandeiras({
					lista: res.data,
					loading: false,
					error: null
				})
			)
		} catch (error) {
			toast.error('As bandeiras não foram carregadas. Por favor atualize a página');
		}
	}

	async function getModalidades(tokenValue, idTitular) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {
			await apiTransacao.get(
				`qtd-transacoes-modalidade/${idTitular}/${moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')}/${moment().format('YYYY-MM-DD')}`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': tokenValue
					}
				}
			).then(res =>
				setModalidade({
					lista: res.data.data,
					loading: false,
					error: null
				})
			)

		} catch (error) {
			toast.error('As modalidades não foram carregadas. Por favor atualize a página');
		}
	}

	async function getTopDiasVendas(tokenValue) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		try {
			await apiTransacao.get(
				`top-dias-transacoes/${user.dados.user_id}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res =>
				setTopDias({
					lista: res.data,
					loading: false,
					error: null
				})
			);
		} catch (error) {
			toast.error('O top dias de vendas não foram carregadas. Por favor atualize a página');
		}
	}

	async function getGraficoEvolutivo(tokenValue) {
		try {
			await apiTransacao.get(
				`transacoes/valores/${user.dados.user_id}?init_date=${moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')}&end_date=${moment().format('YYYY-MM-DD')}&page=1&items=10`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': tokenValue
					}
				}).then(res => {
					getGraficoEvolutivoConcatenado(tokenValue, res.data.transacoes_total)
				})
		} catch (error) {
			toast.error('Os gráficos não foram carregados. Por favor atualize a página');
		}
	}

	async function getGraficoEvolutivoConcatenado(tokenValue, total_registros) {
		if (tokenState) {
			tokenValue = tokenState;
		}
		//Executar após receber dados de getTransacoes
		try {
			await apiTransacao.get(
				`transacoes/valores/${user.dados.user_id}?init_date=${moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')}&end_date=${moment().format('YYYY-MM-DD')}&page=1&items=${total_registros}`,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': tokenValue
					}
				}).then(res => {
					const compareList = res.data.data;
					setGraficoEvolutivo({
						lista: compareList.sort(orderDateMatched),
						loading: false,
						error: null
					})
				})
		} catch (error) {
			toast.error('Os gráficos não foram carregados. Por favor atualize a página');
		}
	}

	/**
	 * Download EXCEL
	 */

	async function download(data, name) {
		var oReq = new XMLHttpRequest();
		oReq.open("POST", "https://api.grupoe2f.com.br/export/export", true);
		oReq.responseType = "blob";
		oReq.setRequestHeader("Content-Type", "application/json");

		let link = document.createElement('a');

		oReq.onload = function (oEvent) {
			var blob = oReq.response;
			link.setAttribute("download", name);
			link.href = URL.createObjectURL(blob);
			// window.location.href = link.href;
			link.setAttribute("href", URL.createObjectURL(blob))
			document.body.appendChild(link)
			link.click();

			setLoaderDownload(false)
		};

		oReq.send(JSON.stringify(data));
	}

	async function getExport(user_id, token, params) {

		try {
			let url = ''
			let data_path = `.data`;
			let payload = {}

			if(['grupo', 'split'].indexOf(user.dados.tipo_cliente) >= 0 && user.dados.permissoes.view_pgm) {
				url = `${process.env.REACT_APP_API_PGM}/transacoes`;
				data_path = `.data`;

				payload = {
					"logo": "lucree",
					"sheet_name": "Planilha Lucree",
					"request": {
						"data_path": data_path,
						"url": url,
						"headers": {
							"Authorization": `Bearer ${user.token.access}`
						},
						"params": {
							"items": 15000,
							"init_date": params.dateInit,
							"end_date": params.dateEnd,
							"documento": user_id !== 'todos' ? user_id : ''
						}
					},
					"styles": [
						{
							"name": "bold",
							"bold": true
						},
						{
							"name": "date",
							"num_format": "DD/MM/YYYY"
						},
						{
							"name": "money",
							"num_format": "#,##0.00;[RED]-#,##0.00"
						}
					],
					"format": {
						"autorizacao": {
							"name": "Autorização",
							"width": 20
						},
						"valor_bruto": {
							"name": "Valor",
							"kind": "number",
							"style": "money",
							"width": 15
						},
						"bandeira": {
							"name": "Bandeira",
							"width": 20
						},
						"modalidade": {
							"name": "Modalidade",
							"width": 30
						},
						"data_transacao": {
							"name": "Data",
							"style": "date",
							"kind": "date",
							"date_format": "%Y-%m-%dT%H:%M:%SZ",
							"width": 25
						},
						"status": {
							"name": "Status",
							"width": 20
						},
						"parcelas": {
							"name": "Parcelas",
							"width": 12
						},
						"nome": {
							"name": "Titular",
							"width": 50
						}
					}
				}
			} else {
				data_path = user_id === 'todos' ? `.data.data` : `.${user_id.toString()}.data`;
				url = user_id === 'todos'
				? `https://api-transacoesdash.lucree.com.br/transacoes-group-concat/${dadosLojista}/${user.dados.lojista_id}`
				: `https://api-transacoesdash.lucree.com.br/transacoes-group/${dadosLojista}/${user.dados.lojista_id}`;

				payload = (user.dados.tipo_cliente === 'grupo' || user.dados.tipo_cliente === 'split') ?
				{
					"logo": "lucree",
					"sheet_name": "Planilha Lucree",
					"request": {
						"data_path": data_path,
						// "data_path": `*.data`,
						"url": url,
						"headers": {
							"Authorization": token
						},
						"params": {
							"items": 15000,
							"init_date": params.dateInit,
							"end_date": params.dateEnd
						}
					},
					"styles": [
						{
							"name": "bold",
							"bold": true
						},
						{
							"name": "date",
							"num_format": "DD/MM/YYYY"
						},
						{
							"name": "money",
							"num_format": "#,##0.00;[RED]-#,##0.00"
						}
					],
					"format": {
						"autorizacao": {
							"name": "Autorização",
							"width": 20
						},
						"valor_bruto": {
							"name": "Valor",
							"kind": "number",
							"style": "money",
							"width": 15
						},
						"bandeira": {
							"name": "Bandeira",
							"width": 20
						},
						"modalidade": {
							"name": "Modalidade",
							"width": 30
						},
						"data_transacao": {
							"name": "Data",
							"style": "date",
							"kind": "date",
							"date_format": "%Y-%m-%d",
							"width": 25
						},
						"status": {
							"name": "Status",
							"width": 20
						},
						"parcelas": {
							"name": "Parcelas",
							"width": 12
						},
						"uf_revenda": {
							"name": "Uf",
							"width": 10
						},
						"nome": {
							"name": "Titular",
							"width": 50
						}
					}
				} : {
					"logo": "lucree",
					"sheet_name": "Planilha Lucree",
					"request": {
						"pagination": {
							"cur_page": {
								"field_params": "page",
								"field_request": "pagina"
							},
							"max_page": {
								"field_request": "paginas"
							}
						},
						"data_path": ".data",
						"url": `https://api-transacoesdash.lucree.com.br/transacoes/${user_id}`,
						"headers": {
							"Authorization": token
						},
						"params": {
							"items": 15000,
							"init_date": params.dateInit,
							"end_date": params.dateEnd
						},
					},
					"styles": [
						{
							"name": "bold",
							"bold": true
						},
						{
							"name": "date",
							"num_format": "DD/MM/YYYY"
						},
						{
							"name": "money",
							"num_format": "#,##0.00;[RED]-#,##0.00"
						}
					],
					"format": {
						"id": {
							"name": "Id",
							"width": 20
						},
						"value": {
							"name": "Valor",
							"kind": "number",
							"style": "money",
							"width": 15
						},
						"brand": {
							"name": "Bandeira",
							"width": 20
						},
						"product": {
							"name": "Modalidade",
							"width": 30
						},
						"payment_date": {
							"name": "Data",
							"style": "date",
							"kind": "date",
							"date_format": "%Y-%m-%d",
							"width": 25
						},
						"status": {
							"name": "Status",
							"width": 20
						},
						"parcels": {
							"name": "Parcelas",
							"width": 12
						},
					}
				}
			}

			download(payload, "vendasLucree.xlsx");
		} catch (error) {
			setLoadingTransactions(false);
			setLoaderDownload(false);
			console.log('Erro no Download Export.');
		}
	}

	async function getExportLucreePorClick(token, page) {
		try {
			const url = `https://ecommerce.lucree.com.br/v3/billing/list/${page}/15000`;

			const payload = {
				"logo": "lucree",
				"sheet_name": "Planilha Lucree",
				"request": {
					"data_path": '.links',
					"url": url,
					"headers": {
						"Authorization": `Basic ${token}`,
						'Content-Type': 'application/json'
					},
				},
				"styles": [
					{
						"name": "bold",
						"bold": true
					},
					{
						"name": "date",
						"num_format": "DD/MM/YYYY"
					},
					{
						"name": "money",
						"num_format": "#,##0.00;[RED]-#,##0.00"
					}
				],
				"format": {
					"created_at": {
						"name": "Data",
						"style": "date",
						"kind": "date",
						"date_format": "%Y-%m-%dT%H:%M:%S",
						"width": 20
					},
					"link_title": {
						"name": "Título",
						"width": 20
					},
					"amount": {
						"name": "Valor",
						"width": 20,
						"nullable": true,
						"style": "money",
						"kind": "number",
						"divisible": true
					},
					"installments": {
						"name": "Parcelas",
						"width": 20
					},
					"paid": {
						"name": "Status",
						"width": 20
					},
				}
			}

			download(payload, "virtualLucree.xlsx");

		} catch (error) {
			setLoadingTransactions(false);
			setLoaderDownload(false);
			console.log('Erro no Download Export.');
		}
	}

	return (
		<TransactionsContext.Provider value={{
			gruposTitularConcatenado,
			loaderDownload,
			setLoaderDownload,
			loadingTransactions,
			setLoadingTransactions,
			transacoes,
			transacoes7Dias,
			transacoesGrupo,
			transacoesDataPickerEnd,
			ultimasTransacoes,
			totalGrupos,
			bandeiras,
			modalidade,
			topDias,
			graficoEvolutivo,
			getTransacoes,
			getTransacoes7Dias,
			getTransacoesDataPickerEnd,
			authGroup,
			authToken,
			authentication,
			getExport,
			getExportLucreePorClick,
			download,
			getAllTransacoesPGM
		}}>
			{children}
		</TransactionsContext.Provider>
	)
}
